import {
  SERVICE_APPROVAL_ACTION_ACCESS,
  formatSupportRoleNames,
  hasAnySupportRole,
} from 'src/supportPortal/access/accessMatrix'

export const REPORT_TYPES_TO_APPROVAL_ROLES = {
  doctor: 'ROLE_DOCTOR',
  therapist: 'ROLE_THERAPIST',
  screener: 'ROLE_SCREENER',
}

export const APPROVAL_ROLES = ['ROLE_DOCTOR', 'ROLE_THERAPIST', 'ROLE_SCREENER']

export const APPROVAL_APIS = {
  ROLE_DOCTOR: '/api/secure/cc/support/privileged/approve/doctor/provide-service-approval',
  ROLE_THERAPIST: '/api/secure/cc/support/privileged/approve/therapist/provide-service-approval',
  ROLE_SCREENER: '/api/secure/cc/support/privileged/approve/screener/provide-service-approval',
}
export const DISAPPROVAL_APIS = {
  ROLE_DOCTOR: '/api/secure/cc/support/privileged/approve/doctor/rescind-service-approval',
  ROLE_THERAPIST: '/api/secure/cc/support/privileged/approve/therapist/rescind-service-approval',
  ROLE_SCREENER: '/api/secure/cc/support/privileged/approve/screener/rescind-service-approval',
}

export const hasExistingApproval = (practitioner, approvalRole) => {
  const approvedServices = Object.entries(
    practitioner?.teacherUnEditableFields?.servicesApproved || {},
  ).some(([key, value]) => key === approvalRole && value.enabled)

  return !!approvedServices
}

export function hasExistingApprovalButDisabled(practitioner, approvalRole) {
  const approvedServices = Object.entries(
    practitioner?.teacherUnEditableFields?.servicesApproved || {},
  ).some(([key, value]) => key === approvalRole && !value.enabled)

  return !!approvedServices
}

export const shouldShowApprovalButton = (practitioner, approvalRole) => {
  // Don't show if already has this approval
  if (hasExistingApproval(practitioner, approvalRole)) {
    return false
  }

  return true
}

export const isServiceDisabled = (practitioner, approvalRole) => {
  // Don't show if already has this approval
  if (hasExistingApproval(practitioner, approvalRole)) {
    return false
  }

  return true
}

export function findApprovalTypeFromApprovalRole(approvalRole, approvalRoles) {
  return approvalRoles?.find((approvalType) => approvalType.id === approvalRole)
}

export function canManageApprovalRole(approvalRole, userRoles = []) {
  return hasAnySupportRole(userRoles, SERVICE_APPROVAL_ACTION_ACCESS[approvalRole] || [])
}

export function getApprovalRoleAccessLabel(approvalRole) {
  return formatSupportRoleNames(SERVICE_APPROVAL_ACTION_ACCESS[approvalRole] || [])
}

export const buildServiceDetailsMap = (approvalType, specializations = []) => {
  const serviceType = REPORT_TYPES_TO_APPROVAL_ROLES[approvalType]
  return {
    enabled: true,
    serviceType,
    specializations,
  }
}
